import { useTranslate } from '@/translations';
import { PageContainer, Title } from '@/ui/components';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { Card } from 'antd';
import React, { FC } from 'react';
import { DamageExceptionDataGrid } from './DamageExceptionDataGrid';

export const DamageExceptions: FC = () => {
  const { t } = useTranslate();

  return (
    <PageContainer>
      <Title title={t('damageExceptions')} icon={faTriangleExclamation} />
      <Card>
        <DamageExceptionDataGrid />
      </Card>
    </PageContainer>
  );
};
